module.exports = __webpack_public_path__ + "img/home_middel_middel.c09a1b55.png";